// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideRows4 as RawLucideRows4 } from "lucide-react";
export const LucideRows4 = /* @__PURE__ */ createIcon(RawLucideRows4, "LucideRows4", 2);
